import {RemoteRefundPostBank} from 'data/usecases';
import {PostBank} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeRefundPostBank = (): PostBank =>
	new RemoteRefundPostBank(
		makeBFFApiUrl(RefundFlowEndPoints.beneficiaryBankData),
		makeAuthorizeHttpClientDecorator(),
	);
